// SelfEliminationModal.js

import React, { useEffect } from 'react';
import { OptimizedModal } from './OptimizedModal'; // Yeni temel bileşen

// ✅ React.memo ile sarmalandı
export const SelfEliminationModal = React.memo(({ onClose, isOpen }) => {
    // 3 saniye sonra otomatik kapat
    useEffect(() => {
        if (!isOpen) return; // Sadece modal açıkken çalış
        const timer = setTimeout(() => {
            onClose();
        }, 3000);

        return () => clearTimeout(timer);
    }, [onClose, isOpen]); // isOpen bağımlılığı eklendi

    return (
        // ✅ OptimizedModal kullanıldı. isOpen={true} çünkü GameScreen'de şartlı render ediliyor.
        <OptimizedModal isOpen={isOpen} onClose={onClose}>
            <div className="bg-gradient-to-br from-red-900 via-gray-900 to-black border-4 border-red-500 rounded-2xl p-8 max-w-md w-full mx-4 shadow-2xl animate-scaleIn">
                <div className="text-center">
                    <div className="mb-6 animate-bounce">
                        <div className="text-8xl">💀</div>
                    </div>

                    <h2 className="text-4xl font-bold text-red-500 mb-4 drop-shadow-lg animate-pulse">
                        ELENDIN!
                    </h2>

                    <p className="text-xl text-gray-300 mb-6 leading-relaxed">
                        Tüm karelerini kaybettin!
                        <br />
                        <span className="text-red-400 font-semibold">Oyundan elendim.</span>
                    </p>

                    <div className="bg-black bg-opacity-40 rounded-lg p-4 mb-4">
                        <div className="text-gray-400 text-sm">
                            3 saniye içinde otomatik kapanacak...
                        </div>
                        <div className="w-full bg-gray-700 rounded-full h-1 mt-2 overflow-hidden">
                            <div className="bg-red-500 h-full animate-shrink" />
                        </div>
                    </div>
                </div>
            </div>

        </OptimizedModal>
    );
});